/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/product-options';

export const ProductOptionApi = {
  create: async (body: any) => {
    const url = pathname;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (body: UpdateMultiProductOptionsBuyProductIDBody) => {
    const url = `${pathname}/multi`;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;
    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateMultiProductOptionsBuyProductIDBody {
  productID: string;
  optionIDs: string[];
}
